import React, { useState, useCallback } from 'react';
import TextBox from 'devextreme-react/text-box';
import Button from 'devextreme-react/button';
import { AntLocalization } from 'ante-react-kit';

export default function CreateView({ initialName, onCancel, onConfirm }) {
    const [name, setName] = useState(initialName || '');
    const [phone, setPhone] = useState('');
    const [legalId, setLegalId] = useState('');

    const canSubmit = !!(name && name.trim()) && !!(phone && phone.trim());

    const handleConfirm = useCallback(() => {
        if (!canSubmit) return;
        onConfirm({
            entity_name: String(name).trim().toUpperCase(),
            entity_contact_phone: String(phone).trim(),
            entity_legal_id: legalId ? String(legalId).trim() : null
        });
    }, [canSubmit, name, phone, legalId, onConfirm]);

    return (
        <div className="apk-create">
            <div className="apk-create__hint">
                {AntLocalization.translateText({
                    vi: 'Nhập thông tin khách hàng mới. Có thể bổ sung chi tiết sau khi tạo.',
                    en: 'Enter new customer info. Additional details can be added later.'
                })}
            </div>
            <div className="apk-create__field">
                <label>
                    {AntLocalization.translateText({ vi: 'Tên khách hàng', en: 'Customer Name' })}
                    <span className="apk-create__required">*</span>
                </label>
                <TextBox
                    value={name}
                    height={46}
                    stylingMode="outlined"
                    placeholder={AntLocalization.translateText({ vi: 'VD: Nguyễn Văn A', en: 'e.g. John Doe' })}
                    onValueChanged={(e) => setName(e.value)}
                />
            </div>
            <div className="apk-create__field">
                <label>
                    {AntLocalization.translateText({ vi: 'Số điện thoại', en: 'Phone' })}
                    <span className="apk-create__required">*</span>
                </label>
                <TextBox
                    value={phone}
                    height={46}
                    stylingMode="outlined"
                    placeholder={AntLocalization.translateText({ vi: 'VD: 0912 345 678', en: 'e.g. 0912 345 678' })}
                    onValueChanged={(e) => setPhone(e.value)}
                    mode="tel"
                />
            </div>
            <div className="apk-create__field">
                <label>{AntLocalization.translateText({ vi: 'CMND/CCCD/MST', en: 'Legal ID' })}</label>
                <TextBox
                    value={legalId}
                    height={46}
                    stylingMode="outlined"
                    placeholder={AntLocalization.translateText({ vi: 'Tùy chọn', en: 'Optional' })}
                    onValueChanged={(e) => setLegalId(e.value)}
                />
            </div>
            <div className="apk-create__actions">
                <Button height={42} text={AntLocalization.translateText({ vi: 'Hủy', en: 'Cancel' })} onClick={onCancel} />
                <Button
                    type="default"
                    stylingMode="contained"
                    height={42}
                    width={180}
                    text={AntLocalization.translateText({ vi: 'Tạo & chọn khách', en: 'Create & Select' })}
                    disabled={!canSubmit}
                    onClick={handleConfirm}
                />
            </div>
        </div>
    );
}
